import 'src/public-path';

import 'common/utils/local-storage-polyfill';

// app dependencies
import 'client/styles/main.scss';

// app
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { IS_DEVEL } from 'utils/environment';
import { location } from 'utils/url-helper';
import Root from 'client/Root';

if (!IS_DEVEL && !location.client.isPreview) {
	Sentry.init({
		dsn: 'https://e6ced77cc723478fad969f5f3ba00b06@o969560.ingest.sentry.io/5920728',
		integrations: [new Sentry.BrowserTracing()],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 0.05,
		release: `story-cards@${process.env.VERSION}`,
		environment: process.env.NODE_ENV,
		denyUrls: [
			// Browser extensions
			/extensions\//i,
			/^chrome:\/\//i,
			/extension:/i,
			/widgetapp/i, // client specific code
			/webkit-masked-url/i, // https://github.com/getsentry/sentry-javascript/discussions/5875
		],
		ignoreErrors: [
			/gtag/i, // client specific code
			/accessibility/i, // client specific code
			/kWidget/i, // client specific code
			/vcmidOfContent/i, // client specific code
			/Walla/i, // client specific code
			/sentryWrapped/i, // sentry specific code
			/@sentry/i, // sentry specific code
			/webkit-masked-url/i, // https://github.com/getsentry/sentry-javascript/discussions/5875
			/zp_token is not defined/i, // client specific code
		],
	});
}

if (process.env.DEBUG !== undefined) {
	localStorage.setItem('debug', process.env.DEBUG);
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
	// <React.StrictMode>
	<Root />
	// </React.StrictMode>
);
